import React, { useEffect, useState, useContext, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { BoxInfo, CircleSpinner, getCountryA3 } from 'shared'
import { MspDispatchContext, MSP_ACTIONS } from 'shared/components/Multistep'

import sddService from 'selfServicePortal/services/CreditCardServices/sddService'

import { SddDispatchContext, SDD_ACTIONS } from '../SDDMultistepValues'

export const SDDTermsAndConditions = () => {
	const { t } = useTranslation()
	const [sdd, dispatchSdd] = useContext(SddDispatchContext) // eslint-disable-line @typescript-eslint/no-unused-vars
	const { msp, dispatchMsp } = useContext(MspDispatchContext) // eslint-disable-line @typescript-eslint/no-unused-vars

	const [terms, setTerms] = useState<string>('asd')
	const [approveTermsAndConditions, setApproveTermsAndConditions] =
		useState<boolean>(false)
	const [error, setError] = useState<boolean>(false)
	const [loading, setLoading] = useState<boolean>(false)

	let country = getCountryA3()

	useEffect(() => {
		dispatchSdd({
			type: SDD_ACTIONS.SET_APPROVE_TERMS,
			payload: {
				approvedTerms: approveTermsAndConditions,
			},
		})
	}, [approveTermsAndConditions, dispatchSdd])

	const getActivePct = useCallback(async (country: string) => {
		try {
			sddService
				.getSddActivePct(country)
				.then((response) => {
					setTerms(response.data.termsAndConditions)
				})
				.catch((error) => {
					console.warn(error)
					setError(true)
				})
		} catch (error) {
			console.warn('Error catch:', error)
			setError(true)
		}
	}, [])

	useEffect(() => {
		dispatchSdd({
			type: SDD_ACTIONS.SET_DESCRIPTION,
			payload: {
				description: 'SDDTermsSubtitle',
			},
		})
		dispatchMsp({
			type: MSP_ACTIONS.SET_NEXTBUTTON_TEXT,
			payload: {
				nextButtonText: 'Fortfahren zur Verifizierung',
			},
		})
		setLoading(true)
		if (country) {
			try {
				getActivePct(country)
			} catch (e) {
				setError(true)
			}
			setLoading(false)
		}
	}, [dispatchSdd, dispatchMsp, country, getActivePct])

	return (
		<div className="sdd-terms-and-conditions">
			{loading ? (
				<CircleSpinner />
			) : (
				<>
					{error ? (
						<BoxInfo css={'fail'} message={t('ErrorMsg')} />
					) : (
						<>
							<div className="sdd-mandate-box">
								<div
									id="sdd-terms"
									dangerouslySetInnerHTML={{
										__html: terms,
									}}></div>
							</div>
							<div className="sdd-mandate-checkbox">
								<label className="checkbox-container">
									<input
										type="checkbox"
										checked={approveTermsAndConditions}
										onClick={() =>
											setApproveTermsAndConditions(
												!approveTermsAndConditions
											)
										}
									/>
									<span className="checkmark"></span>
									{t('SDDApproveTerms')}
								</label>
							</div>
						</>
					)}
				</>
			)}
		</div>
	)
}
